import React, { useEffect } from "react";
import { useDeleteConnectionMutation } from "~/src/state/institutions/institutions-api-slice";
import { toast } from "react-toastify";
import { Toast } from "~/src/components/toast";
import { Icons } from "~/src/assets/icons";
import { removeConnection } from "~/src/state/institutions/institutions-data-slice";
import { useDispatch } from "react-redux";

export const useDeleteConnection = () => {
  const dispatch = useDispatch();
  const [deleteConnectionMutation, deleteConnectionStatus] =
    useDeleteConnectionMutation();

  const { isLoading, isError, isSuccess, data } = deleteConnectionStatus;

  // when the query is in flight, show loading toast, otherwise dismiss it
  useEffect(() => {
    if (isLoading) {
      toast(
        <Toast
          message="Disconnecting connection..."
          icon={Icons.green.LoadingAnimated}
        />,
        { toastId: "deleteConnection", autoClose: false }
      );
    } else toast.dismiss("deleteConnection");
  }, [isLoading]);

  // if the query is successful and returns data, show success toast and update store
  useEffect(() => {
    if (isSuccess && !!data.data) {
      toast(
        <Toast
          message="Connection was successfully disconnected!"
          icon={Icons.green.Info}
        />
      );
      dispatch(removeConnection(data.data));
    }
  }, [isSuccess, data]);

  // if the query errors or returns an error, show error toast
  useEffect(() => {
    if (isError || !!data?.errors) {
      toast(
        <Toast
          message="There was a problem disconnecting the connection. Please try again."
          icon={Icons.green.Info}
        />
      );
    }
  }, [isError, data]);

  return { deleteConnectionMutation, isLoading };
};
